import React from 'react'

import type { ButtonProps } from 'components/_new/controls'

import AddToCartButton, { AddToCartMetadata } from '../AddToCartButton/AddToCartButton'
import AddToQueueButton, { AddToQueueMetadata } from '../AddToQueueButton/AddToQueueButton'
import type { AddToProps } from '../util'


export type AddToQueueOrCartMetadata = AddToQueueMetadata | AddToCartMetadata

export type AddToQueueOrCartButtonProps = {
  addTo: 'cart' | 'queue'
} & AddToProps<AddToQueueOrCartMetadata, AddToQueueOrCartMetadata> // ATTN it should be both, because switching between buttons is a runtime operation

// ATTN it should be function, because generics integration with arrow functions is bad
// To use custom component, pass Component props as argument <AddToQueueOrCartButton<LinkProps> component={Link} />
function AddToQueueOrCartButton<ComponentProps = ButtonProps>(props : AddToQueueOrCartButtonProps & ComponentProps) {
  const { addTo, ...rest } = props

  if (addTo === 'cart') {
    // @ts-ignore
    return <AddToCartButton<ComponentProps> {...rest} />
  }

  if (addTo === 'queue') {
    // @ts-ignore
    return <AddToQueueButton<ComponentProps> {...rest} />
  }

  throw new Error(`wrong addTo (${addTo}) passed to AddToQueueOrCartButton`)
}


export default AddToQueueOrCartButton
